import { useOverlayTriggerState } from '@react-stately/overlays';
import React, { createContext, useState } from 'react';

export type TMobileMenuPage = 'main' | 'login' | 'auctions' | 'consignment' | 'latest'
| 'company' | 'locations' | 'account' | 'account/profile'
| 'account/consignment' | 'account/settings' | 'account/buying';

export type THeaderContext = {
  megaMenuState?: ReturnType<typeof useOverlayTriggerState>,
  accountMenuState?: ReturnType<typeof useOverlayTriggerState>,
  mobileMenuState?: ReturnType<typeof useOverlayTriggerState>,
  settingsMenuState?: ReturnType<typeof useOverlayTriggerState>,

  mobileMenuPage?: TMobileMenuPage,
  setMobileMenuPage?: React.Dispatch<React.SetStateAction<TMobileMenuPage>>,

  liveVideoOpen?: boolean,
  setLiveVideoOpen?: React.Dispatch<React.SetStateAction<boolean>>,

  openLoginMenu?: () => void,
}

export const HeaderContext = createContext<THeaderContext>({
});

export const HeaderContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const megaMenuState = useOverlayTriggerState({});
  const accountMenuState = useOverlayTriggerState({});
  const mobileMenuState = useOverlayTriggerState({});
  const settingsMenuState = useOverlayTriggerState({});
  const [mobileMenuPage, setMobileMenuPage] = useState<TMobileMenuPage>('main');
  const [liveVideoOpen, setLiveVideoOpen] = useState(true);
  return <HeaderContext.Provider value={{
    megaMenuState,
    accountMenuState,
    mobileMenuState,
    settingsMenuState,
    mobileMenuPage,
    setMobileMenuPage,
    liveVideoOpen,
    setLiveVideoOpen,
    openLoginMenu: () => {
      if(window.innerWidth > 1024) {
        accountMenuState.open();
      } else {
        mobileMenuState.open();
        setMobileMenuPage('login');
      }
    },
  }}>
    {children}
  </HeaderContext.Provider>;
};

export const useHeaderContext = (): THeaderContext => {
  return React.useContext(HeaderContext);
};
